// removed by extract-text-webpack-plugin
module.exports = {"container":"tejVPuqpSJ3wlrxEcif68","edit_btn":"L8BHphOi9fOlAMKJUur2g","group_container":"ZYisR7aJr70p2isyz-YFp","group_name":"_10o0HIZJ0vDBGoVlWvODY5","url_list":"_3M0XKh-pS0TuKZLfk4IkG1","handle_add":"_1xVqZOaQCofNbu4jI9ZFaz","edit_list":"_18dnCfPix-5bocEExBg1Ns","modal_container":"_27lThhT4SfJqhKQJlmhbYs","my_url_Content":"YN-5FKp7ODNHKWp3xY_Ed","close_icon":"_2HgWwPh3XDd-TW2J8WUnW","my_url_list":"_26_hlG38yObNDG67Wr2VA4","common_list":"_2zLacwx83gA6ktiXutH1mC"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Navigation/index.less
// module id = 492
// module chunks = 0